import { washLanguageData, washNumButton } from '@/utils/wash.js'
const washData = (node) => {
  try {
    switch (node._type) {
      case 'list_download_one':
        washLanguageData(node, 'w-col home-list-download-btn')
        washNumButton(node, 'w-col home-download-title')
        break
      case 'list_download_two':
        washLanguageData(node, 'w-col home-list-download-btn')
        break
    }
  } catch (err) {
    console.log('err--', err)
  }
}
export { washData }
